<template>
	<assign-table
		ref="table"
		:items="items"
		:headers
		:loading
		stage="pick"
		@select="(value: Array<Object>) => emit('select', value)"
		@update="(item: CollectionItem, kit: CollectionItem) => emit('update', item, kit)"
		@updated-items="emit('updatedItems')" />
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import { ref } from 'vue'
	import AssignTable from '../../all/AssignTable.vue'
	import type { CollectionItem } from '@/data/schema/collection-item'

	const table = ref()

	defineProps({
		items: {
			type: Array<CollectionItem>,
			default: []
		},
		loading: Boolean
	})

	const headers: Header[] = [
		{ value: 'collection_status', text: 'Status', props: { width: 100 } },
		{ value: 'item_number', text: 'Item Number', props: { sortable: true, width: 100 } },
		{ value: 'item_description', text: 'Item Description', props: { width: 250 } },
		{
			value: 'journey_number',
			text: 'Journey Number',
			props: { sortable: true, showFilterMenu: false }
		},
		{ value: 'item_weight', text: 'Weight', props: { sortable: true } },
		{ value: 'quantity_on_hire', text: 'OH Qty', props: { sortable: true } },
		{ value: 'quantity_recorded', text: 'Qty Rec', props: { sortable: true } },
		{ value: 'quantity_ok', text: 'OK', props: { sortable: true } },
		{ value: 'quantity_damaged', text: 'DAM' },
		{ value: 'damage_code', text: 'DAM CODE' },
		{ value: 'collection_assigned_to', text: 'Assign to Yard Op' },
		{ value: 'collection_notes', text: 'Notes' }
	]

	// Events
	const emit = defineEmits(['select', 'update', 'updatedItems'])

	// Expose
	defineExpose({ updateOperators })

	/**
	 * Exposed function to bulk update all operators
	 * @param operator string
	 */
	function updateOperators(operator: string) {
		table.value.updateOperators(operator)
	}
</script>
